import { resolveTrackChangeAuthorSide } from './reviewPartyContext';
import { wrapSquareBracketsForRtlHtml } from './textUtils';
import { TrackChangesParser } from '../word/utils/TrackChangesParser';

type ResolveSide = (author: string) => 'our' | 'their' | null;

/**
 * Color existing redlines by Review side assignment (our = blue, their = red).
 */
export function colorHtmlByReviewAuthorSide(
  html: string,
  resolve: ResolveSide = resolveTrackChangeAuthorSide,
): string {
  try {
    const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
    const root = doc.body.firstElementChild;
    if (!root) return html;
    root.querySelectorAll('ins, del').forEach((el) => {
      const title = el.getAttribute('title') || '';
      const author = title.replace(/^Author:\s*/i, '').trim();
      if (!author) return;
      const side = resolve(author);
      if (side === 'our') el.classList.add('track-change-new');
      else if (side === 'their') el.classList.remove('track-change-new');
    });
    return root.innerHTML;
  } catch {
    return html;
  }
}

export function prepareTrackChangesPreviewHtml(
  html: string,
  resolve: ResolveSide = resolveTrackChangeAuthorSide,
): string {
  return colorHtmlByReviewAuthorSide(wrapSquareBracketsForRtlHtml(html), resolve);
}

export function ooxmlToPartyTrackChangesHtml(
  ooxml: string,
  resolve: ResolveSide = resolveTrackChangeAuthorSide,
): string | null {
  try {
    const raw = TrackChangesParser.convertOoxmlToHtml(ooxml);
    if (!raw?.trim()) return null;
    return prepareTrackChangesPreviewHtml(raw, resolve);
  } catch {
    return null;
  }
}
